import React from 'react';
import { Grid } from '@mui/material';
import BuyerInventoryRecordCard from './BuyerInventoryRecordCard';
import NoMatchingInvoicesFound from '../../NoMatchingInvoicesFound';
import InfoCardLoadingSkeleton from '../../skeleton/InfoCardLoadingSkeleton';

const BuyerInventoryRecords = ({ loading, inventoryRecords, handleDeleteCorrection, handleSubmitCorrection }) => {

    const formatName = (first, last) => {
        const nameParts = [first, last].filter(Boolean);
        return nameParts.length > 0 ? nameParts.join(' ') : '-';
    };

    const formatRecord = (record) => {
        const {checkinDriverFirstName, checkinDriverLastName, checkoutDriverFirstName, checkoutDriverLastName} = record;
        
        const checkinDriverName = formatName(checkinDriverFirstName, checkinDriverLastName);
        const checkoutDriverName = formatName(checkoutDriverFirstName, checkoutDriverLastName);

        const {checkInCorrectionStatus, checkOutCorrectionStatus} = record;
        let corrections = [];
        if (checkInCorrectionStatus) {
            corrections.push(` Check In: ${checkInCorrectionStatus}`);
        }
        if (checkOutCorrectionStatus) {
            corrections.push(` Check Out: ${checkOutCorrectionStatus}`);
        }

        return {...record, checkInDriverName: checkinDriverName, checkOutDriverName: checkoutDriverName, existingCorrections: corrections};
    };

    return <Grid container direction="column">
        {
            loading ? 
                <InfoCardLoadingSkeleton/>
            :
            <Grid item container>
                {
                    inventoryRecords.length > 0 ? 
                        inventoryRecords.map(item => <BuyerInventoryRecordCard inventoryRecord={formatRecord(item)} key={item.id} handleDeleteCorrection={handleDeleteCorrection} handleSubmitCorrection={handleSubmitCorrection}/>)
                    : <NoMatchingInvoicesFound message="No Records Found"/>
                }
            </Grid>
        }
        </Grid>
};

export default BuyerInventoryRecords;